module.exports = __webpack_public_path__ + "static/media/manager-smart.e98eccb6.svg";